import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AxiosProvider } from '../../context/AxiosContext';
import ErrorBoundary from './ErrorBoundary';
import Layout from './Layout';
import {
  BannerEditorScreen, BannersScreen, CardEditorScreen, CardsScreen, OrderScreen,
} from './screens';

const Promotions = ({ email, referrers }) => (
  <ErrorBoundary>
    <AxiosProvider layout="promotions">
      <Routes>
        <Route element={<Layout email={email} referrers={referrers} />}>
          <Route index element={<Navigate to="cards" replace />} />
          <Route path="cards" element={<CardsScreen />} />
          <Route path="cards/new" element={<CardEditorScreen />} />
          <Route path="cards/:id/edit" element={<CardEditorScreen />} />
          <Route path="banners" element={<BannersScreen />} />
          <Route path="banners/new" element={<BannerEditorScreen />} />
          <Route path="banners/:id/edit" element={<BannerEditorScreen />} />
          <Route path="order" element={<OrderScreen />} />
          <Route path="*" element={<Navigate to="cards" replace />} />
        </Route>
      </Routes>
    </AxiosProvider>
  </ErrorBoundary>
);

Promotions.propTypes = {
  email: PropTypes.string,
  referrers: PropTypes.array,
};

export default Promotions;
